interface ByteFormatterOptions {
  bytes: number,
  fraction?: number,
  onlyUnit?: boolean,
  unit?: string
  allowHigherUnits?: boolean,
}

class ByteFormatter {
  /**
   * サポートする単位
   */
  private static _supportedByteUnits: ReadonlyArray<string> = ["B", "KB", "MB", "GB", "TB"];

  /**
   * サポートする単位の取得
   */
  static get supportedByteUnits() {
    return this._supportedByteUnits;
  }

  /**
   * 通信量統計用のByte変換処理
   */
  public static formatBytes({bytes, fraction, onlyUnit, unit, allowHigherUnits}: ByteFormatterOptions) {
    const units = this._supportedByteUnits;

    // 単位の自動指定処理
    let n: number = bytes <= 0 ? 0 : Math.trunc(Math.log(bytes) / Math.log(1024));
    n = Math.min(units.length - 1, Math.max(1, n));

    // 単位指定がある場合
    if (unit != null) {
      let n2 = units.indexOf(unit);
      if (n2 > 0) {
        // 単位指定より大きい場合を確認
        if (!allowHigherUnits || n2 > n) {
          n = n2;
        }
      }
    }

    // 単位だけを取得する場合
    if (!!onlyUnit) {
      return units[n];
    }

    // 表記計算
    const value = bytes / Math.pow(1024, n);

    // 小数点以下の文字数の自動設定処理
    let f: number = 0;
    if (fraction != null) {
      f = fraction;
    } else {
      if (1000 <= value) {
        f = 0;
      } else if (100 <= value) {
        f = 1;
      } else if (10 <= value) {
        f = 2;
      } else {
        f = 3;
      }
    }

    return value.toFixed(f) + units[n];
  }
}

export default ByteFormatter;